import { Dropdown } from "antd";
import styled, { createGlobalStyle } from "styled-components";

export const StyledDropdown = styled(Dropdown)<{ position: { x: number; y: number } }>`
  position: absolute;
  left: ${(props) => props.position.x}px;
  top: ${(props) => props.position.y}px;
  z-index: 3;

`;

export const SelectDropdownStyle = createGlobalStyle`
    .icon-wrapper-flow {
      margin-right: ${({ theme: { token } }) => token.marginXS}px;
    }
`;